import { IWhiteLabelInfos } from "./whitelabel-infos.interface";

const themeConfig: IWhiteLabelInfos[] = [
  {
    workspace: 'vistoriabb',
    colors: {
      primary: '',
      secondary: '',
      success: '',
      error: '',
      warning: '',
      info: '',
    },
    logo: 'bb-logo.png',
    title: 'Banco do Brasil',
    allowAgriculturalMachine: true,
    allowVessel: false,
    allowAgriculturalMachineVehicleType: false,
    partnerLogo: "bbrasil/banco-do-brasil-logo.png",
    // api: "c2z1LjzND52NNZ", STG
    api: "9gX9aqgh3TaWTZ",
    price: "69,91"
  },
  {
    workspace: 'vistoriasicredi',
    colors: {
      primary: '',
      secondary: '',
      success: '',
      error: '',
      warning: '',
      info: '',
    },
    logo: 'sicredi-logo.png',
    title: 'Sicredi',
    allowAgriculturalMachine: true,
    allowVessel: true,
    allowAgriculturalMachineVehicleType: true,
    partnerLogo: "",
    // api: "e0QYwzCO7j53T0", STG
    api: "AQhT01MAW9mW0r",
    price: "60,00"
  },
];

export default themeConfig;
